import { render, staticRenderFns } from "./ContentDuplicate.vue?vue&type=template&id=0682d187"
import script from "./ContentDuplicate.vue?vue&type=script&lang=js"
export * from "./ContentDuplicate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports